<template>
  <div></div>
</template>

<script>
import { getEnvironment, envConfigs } from "@/auth";
import { OktaAuth } from "@okta/okta-auth-js";

export default {
  name: "Login",

  data() {
    return {};
  },

  created: function() {
    this.env = getEnvironment();
    this.config = envConfigs[this.env];
    this.oktaAuth = new OktaAuth(this.config);
    this.oktaAuth.tokenManager.clear();
    this.oktaAuth.options.grantType = "authorization_code";
    this.oktaAuth.token.getWithRedirect({
      scopes: ["openid", "profile"],
      state: btoa(JSON.stringify({ variantName: "www" })),
    });
  },
  beforeMount: function() {},

  mounted: function() {},

  methods: {},
};
</script>
